import styled from '@emotion/styled'
import { spacing, font, colors } from '@mobi/component-library/Foundations'

export const RadioLabel = styled.div({
  display: 'block',
  fontFamily: font.family.primary,
  fontWeight: font.weight.medium,
  ...font.size.lg,
  marginBottom: spacing.smx1,
  color: colors.black,
  flex: 1,
})

export const RadioGroup = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx1,
})

export const RadioOption = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'left',
  gap: spacing.sm,
})

export const RadioOptionLabel = styled.label({
  ...font.size.lg,
  color: colors.neutral[900],
  cursor: 'pointer',
})
